/**
 * Stamps Board Configuration
 *
 * Configuration for the stamps board instance.
 * Includes single category with linked items support (no action items or fuel calculator).
 */

import { getStampsCollectionPath, getStampsRTDBPath } from '@/shared/config';
import type { BoardConfig } from '../types';
import type { StatusColors } from '@/types';
import { RESERVATION_CELL_SELECT } from '../utils/reservationStatusColors';

/**
 * Stamps category type (1 category only)
 */
export type StampsCategoryType = 'stamps';

/**
 * Stamps status colors.
 *
 * The comment here used to read "different styling from rentals", but the map
 * was byte-identical to shared.config's `statusColors`; both now point at the
 * same palette-module export (MUST #6). If the stamps board ever does need its
 * own treatment, add a second map to utils/reservationStatusColors.ts rather
 * than re-inlining one here.
 */
export const stampsStatusColors: StatusColors = RESERVATION_CELL_SELECT;

/**
 * Stamps board configuration
 */
export const STAMPS_CONFIG: BoardConfig<StampsCategoryType> = {
  boardType: 'stamps',

  categories: ['stamps'] as const,

  categoryDisplayNames: {
    stamps: 'Stamps',
  },

  features: {
    linkedItems: false,     // Stamps do not use linked items
    actionItems: false,     // No action items in stamps
    fuelCalculator: false,  // No fuel calculator in stamps
    itemFlags: false,       // No item flags in stamps
  },

  getCollectionPath: getStampsCollectionPath,
  getRTDBPath: getStampsRTDBPath,
};
